import useScrollAnimation from '../../hooks/useScrollAnimation';
import { useAppMotionContext } from '../../context/AppMotionContext';

const ScrollAnimation = ({ 
  children, 
  className = '', 
  animationType = 'fadeUp',
  delay = 0,
  duration = 600,
  threshold = 0.1,
  triggerOnce = true 
}) => {
  const { isStatic } = useAppMotionContext();
  const [ref, isVisible] = useScrollAnimation({ threshold, triggerOnce });

  if (isStatic) {
    return <div className={className}>{children}</div>;
  }

  const animationClasses = {
    fadeUp: 'opacity-0 translate-y-8',
    fadeDown: 'opacity-0 -translate-y-8',
    fadeLeft: 'opacity-0 -translate-x-8',
    fadeRight: 'opacity-0 translate-x-8',
    fade: 'opacity-0',
    scale: 'opacity-0 scale-95',
  };

  const visibleClasses = {
    fadeUp: 'opacity-100 translate-y-0',
    fadeDown: 'opacity-100 translate-y-0',
    fadeLeft: 'opacity-100 translate-x-0',
    fadeRight: 'opacity-100 translate-x-0',
    fade: 'opacity-100',
    scale: 'opacity-100 scale-100',
  };

  const baseClass = animationClasses[animationType] || animationClasses.fadeUp;
  const visibleClass = visibleClasses[animationType] || visibleClasses.fadeUp;

  return (
    <div
      ref={ref}
      className={`scroll-animate-in transition-[opacity,transform] ease-out ${baseClass} ${
        isVisible ? visibleClass : ''
      } ${className}`}
      style={{
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
};

export default ScrollAnimation;
